module.exports = __webpack_public_path__ + "static/media/CIDQ Logo.00bcd0ce.png";